export default {
  app: {
    collisionDistance: 22,
    doubleClickDistance: 20,
    maxFrequency: 1500,
  },
  transport: {
    height: 65,
  },
  canvas: {
    backgroundColor: 'rgba(0, 0, 0, 0.0)',
  },
  particle: {
    count: 1,
  },
  midi: {
    color: 'limegreen',
  },
  stream: {
    color: 'deeppink',
    easingFactor: 0.08,
    size: 100,
    strokeStyle: 'gray',
    lineWidth: 2,
    lineDash: [3, 30],
  },
  circularStream: {
    strokeStyle: 'gray',
    lineWidth: 2,
    lineDash: [3, 3],
    fillStyle: 'gold',
    textAlign: 'center',
  },
  linearStream: {
    strokeStyle: 'gray',
    lineWidth: 2,
    lineDash: [3, 3],
    fillStyle: 'gold',
    textAlign: 'center',
  },
  selectedStream: {
    strokeStyle: 'gold',
  },
  link: {
    strokeStyle: 'gray',
    lineWidth: 3,
    lineDash: [3, 3],
  },
  unlink: {
    strokeStyle: 'crimson',
  },
  knob: {
    zeroColor: 'dimgray',
  },

  controlPanel: {
    width: 300,
  },
  menu: {
    width: 56,
  },
};
